import { Cancel02Icon } from '@hugeicons-pro/core-solid-rounded'

import { HugeiconsIcon } from '@hugeicons/react'

import { useLevelContext } from '@/features/level-play'
import { useFlow } from '@/shared/lib/steps-flow'

export const LevelFooterWrongAnswerAlert = () => {
  const { state } = useFlow()

  const { journeyAllowWrongAnswers, challenges } = useLevelContext()

  if (state.phase !== 'LOCKED_WRONG') return null

  const currentStep = state.steps[state.currentIndex]
  const currentChallengeId = currentStep?.challengeId
  const currentChallenge = challenges.find(ch => ch.id === currentChallengeId)
  const title = currentChallenge?.wrong_answer_message?.trim() || 'Resposta incorreta'

  let livesLeftMessage = ''
  if (state.lives >= 5)
    livesLeftMessage = `Você tem ${state.lives} corações restantes, tente novamente.`
  else if (state.lives > 3)
    livesLeftMessage = `Ainda restam ${state.lives} corações. Continue com atenção.`
  else if (state.lives == 3)
    livesLeftMessage = `Fique atento, só restam ${state.lives} corações. Foco!`
  else if (state.lives == 2)
    livesLeftMessage = `Apenas ${state.lives} corações restantes. Muito cuidado 🥶`
  else if (state.lives == 1)
    livesLeftMessage = `Último coração. Respire fundo e concentre-se no desafio.`
  else
    livesLeftMessage = `Game over. Tente novamente e aprimore suas habilidades.`

  return (
    <div className="absolute bottom-[-30px] left-0 w-full px-6 pt-6 pb-20 border-t bg-tie rounded-b-xl md:pt-8 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-2">
          <HugeiconsIcon
            icon={Cancel02Icon}
            variant="duotone"
            className="text-white"
            size={20}
          />
          <span className="font-sans text-lg font-bold text-white">
            {title}
          </span>
        </div>
        {!journeyAllowWrongAnswers && (
          <span className="text-base text-white">{livesLeftMessage}</span>
        )}
      </div>
    </div>
  )
}
